import React from "react";

const Montagem = () => {
  return <div>Montagem</div>;
};

export default Montagem;
